import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactComponent } from './contact.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { DsrIconsModule } from '@desyre/icons-angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactPopupComponent } from './contact-popup/contact-popup.component';

@NgModule({
  declarations: [
    ContactComponent,
    ContactPopupComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatDialogModule,
    MatFormFieldModule,
    SharedModule,
    MatIconModule,
    MatButtonModule,
    DsrIconsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ContactRoutingModule
  ],
  exports: [
    ContactComponent
  ]
})

export class ContactModule { }